export enum TextJustify {
  LEFT,
  RIGHT,
  CENTER,
  JUSTIFY_LAST_LINE_LEFT,
  JUSTIFY_LAST_LINE_RIGHT,
  JUSTIFY_LAST_LINE_CENTER,
  JUSTIFY_LAST_LINE_FULL,
}
